import i18n from 'i18n/i18n';
const localize = i18n.loc.localize;

const schema = {
	'mlsOfficeId': (value, state, includeAllField) => {
		if (state.touched['mlsOfficeId'] || includeAllField) {
			if (!(value || '').trim()) {
				return localize('required-field');
			}
		}
	},
};

export default schema;


// WEBPACK FOOTER //
// ./src/components/Modal/AddMlsOfficeModalSchema.js